export default __webpack_public_path__ + "static/media/40.76c062ec.svg";